import { Column, Entity, JoinColumn, OneToMany, ManyToOne, PrimaryGeneratedColumn, OneToOne } from 'typeorm';
import { BaseEntite, Client, EntiteStatique, FiltrableEntiteStatique, Lieu } from '.';
import ActiviteEntente from './activite-entente.entity';
import ContactEntente from './contact-entente.entity';
import ConditionEntente from './condition-entente.entity';
import NoteEntente from './note-entente.entity';
import { Courriel } from './courriel.entity';
import { Horaire } from './horaire.entity';

@FiltrableEntiteStatique<Entente>()
@EntiteStatique()
@Entity('entente')
export class Entente implements BaseEntite {
    static key = 'ententes';

    static non_privileged_properties: (keyof Entente)[] = [];
    static regular_privileged_properties: (keyof Entente)[] = ['id', 'name'];
    static admin_privileged_properties: (keyof Entente)[] = [];

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ type: 'text', nullable: true })
    name = '';

    @Column({ nullable: true })
    fk_id_client: number;

    @ManyToOne(() => Client)
    @JoinColumn({ name: 'fk_id_client', referencedColumnName: 'id' })
    client: Client;

    @OneToMany(() => ContactEntente, (contactEntente: ContactEntente) => contactEntente.entente, { cascade: true })
    @JoinColumn({ name: 'id', referencedColumnName: 'fk_id_entente' })
    contacts: ContactEntente[];

    @Column({ nullable: true })
    fk_id_lieu: number;

    @ManyToOne(() => Lieu)
    @JoinColumn({ name: 'fk_id_lieu', referencedColumnName: 'id' })
    lieu: Lieu;

    @Column({ nullable: true })
    fk_id_lieu_facturation: number;

    @ManyToOne(() => Lieu, { eager: true })
    @JoinColumn({ name: 'fk_id_lieu_facturation', referencedColumnName: 'id' })
    adresse_facturation: Lieu;

    @OneToOne(() => Horaire, { cascade: true })
    @JoinColumn({ name: 'fk_id_horaire', referencedColumnName: 'id' })
    horaire: Horaire;

    @Column({ nullable: true })
    fk_id_horaire: number;

    @OneToMany(() => ConditionEntente, (condition: ConditionEntente) => condition.entente, { cascade: true })
    conditions: ConditionEntente[];

    conditionsFormulaire: string[];

    @Column({ nullable: true })
    contexte: string;

    @OneToMany(() => ActiviteEntente, (activite_entente: ActiviteEntente) => activite_entente.entente, {
        cascade: true,
    })
    activiteEntentes: ActiviteEntente[];

    @OneToMany(() => NoteEntente, (note_entente: NoteEntente) => note_entente.entente, {
        cascade: true,
    })
    notes: NoteEntente[];

    @Column({ nullable: true })
    statut: string;

    @Column({ nullable: true })
    roles: string;

    @Column({ type: 'timestamp', nullable: true })
    date_activite: string = null;

    @Column({ type: 'text', default: '' })
    groupe_age = '';

    @Column({ type: 'boolean', nullable: true, default: false })
    afficher_grandeur_gym: boolean;

    @Column({ nullable: true })
    est_sortie: boolean;

    @Column({ nullable: true })
    note_interne_invisible: boolean;

    @Column({ nullable: true })
    note_client_invisible: boolean;

    @Column({ nullable: true })
    note_fournisseur_invisible: boolean;

    @OneToMany(() => Courriel, (courriel: Courriel) => courriel.entente)
    courriels: Courriel[];

    @Column({ type: 'boolean', nullable: true, default: false })
    copie_locale_client: boolean;
}
